/* eslint-disable react/no-unused-state */
import React, { PureComponent } from 'react';
import ExperimentProviderContext from './ExperimentProviderContext';
import { Experiments, ServerCookies, ProviderDefaults, UpdateExperiments } from './SharedTypes';
import RegisterMultipleExperiments from './Experiment/RegisterMultipleExperiments';

type ownProps = typeof ExperimentProvider.defaultProps & {
  serverCookies?: ServerCookies;
  defaults?: ProviderDefaults;
  preloadedExperiments?: Experiments;
  onPageLoadExperiments?: Experiments;
};

type ownState = {
  experiments: Experiments;
  updateExperiment: UpdateExperiments;
  serverCookies: ServerCookies;
  defaults: ProviderDefaults;
};

class ExperimentProvider extends PureComponent<ownProps, ownState> {
  static defaultProps = {
    serverCookies: {},
    defaults: {},
    preloadedExperiments: {},
    onPageLoadExperiments: {}
  };

  constructor(props) {
    super(props);
    const {
      serverCookies,
      defaults,
      preloadedExperiments,
      onPageLoadExperiments
    } = props;

    this.state = {
      experiments: {
        ...onPageLoadExperiments,
        ...preloadedExperiments
      },
      updateExperiment: (name, updatedExperiments) => {
        this.setState(({ experiments }) => ({
          experiments: {
            ...experiments,
            [name]: updatedExperiments[name]
          }
        }));
      },
      serverCookies,
      defaults
    };
  }

  componentDidMount() {
    const { onPageLoadExperiments } = this.props;
    if (onPageLoadExperiments) {
      this.registerPageLoadExperiments();
    }
  }

  registerPageLoadExperiments() {
    const { onPageLoadExperiments } = this.props;
    const { experiments, updateExperiment, serverCookies, defaults } = this.state;

    const experimentsToRegister = Object.keys(onPageLoadExperiments).map(name => {
      const { defaultBucket = 'control' } = onPageLoadExperiments[name];
      return {
        experimentName: name,
        defaultBucket
      };
    });

    RegisterMultipleExperiments({
      ...defaults,
      experimentsToRegister,
      ignoreExistingExperiments: true,
      experiments,
      serverCookies
    }, updateExperiment);
  }

  render() {
    const { children } = this.props;

    return (
      <ExperimentProviderContext.Provider value={this.state}>
        {children}
      </ExperimentProviderContext.Provider>
    );
  }
}

export default ExperimentProvider;
